import { FaUsersGear } from "react-icons/fa6";
import { RiAdminFill } from "react-icons/ri";
import { IoTicket } from "react-icons/io5";

export const AdminMenu = [
    {
        name: "Users",
        link: "/admin/users",
        icon: <FaUsersGear size={20} />,
    },
    {
        name: "Admins",
        link: "/admin/admins-list",
        icon: <RiAdminFill size={20} />,
    },
    {
        name: "Draws",
        link: "/admin/draws",
        icon: <IoTicket size={20} />,
    },
];
